import { useEffect } from 'react';

export const useScrollLock = (isLocked: boolean) => {
  useEffect(() => {
    const body = document.body;
    const html = document.documentElement;

    let scrollY = 0;

    if (isLocked) {
      // 1. Guardar posición actual del scroll
      scrollY = window.scrollY;

      // 2. Aplicar clase (si usas Tailwind o CSS)
      body.classList.add('overflow-hidden');

      // 3. Estilos inline (fallback si no tienes Tailwind)
      body.style.overflow = 'hidden';
      html.style.overflow = 'hidden';

      // 4. Fijar posición para evitar salto al desbloquear
      body.style.position = 'fixed';
      body.style.top = `-${scrollY}px`;
      body.style.width = '100%';
    } else {
      // Eliminar estilos y restaurar scroll
      const prevTop = body.style.top;

      body.classList.remove('overflow-hidden');
      body.style.overflow = '';
      html.style.overflow = '';
      body.style.position = '';
      body.style.top = '';
      body.style.width = '';

      // Restaurar posición de scroll
      if (prevTop) {
        const y = parseInt(prevTop || '0') * -1;
        window.scrollTo(0, y);
      }
    }

    return () => {
      // Cleanup seguro por si se desmonta con bloqueo activo
      body.classList.remove('overflow-hidden');
      body.style.overflow = '';
      html.style.overflow = '';
      body.style.position = '';
      body.style.top = '';
      body.style.width = '';
    };
  }, [isLocked]);
};
